import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureScrollerComponent } from './feature-scroller.component';

@NgModule({
  declarations: [
    FeatureScrollerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FeatureScrollerComponent
  ]
})
export class FeatureScrollerModule {}


